module.exports = __webpack_public_path__ + "c3b6d6d90d63d42ec77fbe677d583872.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/tna.png
// module id = 626
// module chunks = 0